var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 188,
    viewBox: "0 0 210 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 173.904C4.00367 171.99 4.49466 170.111 5.42806 168.444L95.4223 8.80987C97.4283 5.21527 101.214 2.99304 105.313 3.00002C109.42 3.01068 113.206 5.22593 115.239 8.80987L204.572 168.48C205.509 170.132 206.003 172.001 206 173.905C206 180.033 201.058 185 194.96 185H15.0405C8.94537 185 4 180.033 4 173.904Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.578 168.424L148.26 67C129.676 117.42 93.7079 159.332 47 185H195.007C201.079 185 206 180.017 206 173.867C206.003 171.957 205.514 170.081 204.578 168.424Z",
    fill: "#FFB802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.335 7.53961C114.265 0.395195 105.147 -2.11167 97.9656 1.93384C95.6137 3.26031 93.6643 5.19636 92.3305 7.53961L1.89109 166.343C0.69057 168.474 0.0429372 170.866 0.00110145 173.307C-0.0969254 181.325 6.36054 187.902 14.4209 188C14.4804 188 14.5398 188 14.596 188H195.405C203.444 188.021 209.982 181.552 210 173.551C210.007 171.037 209.356 168.565 208.11 166.378L118.335 7.53961ZM195.405 181.036H14.596C10.403 181.029 7.00817 177.641 7.01145 173.47C7.01514 172.182 7.34737 170.915 7.98106 169.79L98.4204 10.9519C100.562 7.16383 105.385 5.81981 109.194 7.95049C110.457 8.65717 111.5 9.69477 112.211 10.9519L202.02 169.79C204.067 173.432 202.762 178.035 199.105 180.072C197.974 180.702 196.7 181.033 195.405 181.036Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 50H99V129H112V50Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 147H99V161H112V147Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.28f7568e2e155a8aabfc4c55499ee6e1.svg";
export { ForwardRef as ReactComponent };